import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import "./../css/LayoutDualSidebar.scss";

export default class LayoutDualSidebar extends Component {
    state = {
        leftOpen: true,
        rightOpen: false
    };

    toggleLeft = () => this.setState(prev => ({ leftOpen: !prev.leftOpen }));
    toggleRight = () => this.setState(prev => ({ rightOpen: !prev.rightOpen }));

    render() {
        const { leftOpen, rightOpen } = this.state;
        const { LeftSidebar, RightSidebar, children } = this.props;

        return (
            <div className={`dual-layout ${leftOpen ? "left-open" : "left-closed"} ${rightOpen ? "right-open" : "right-closed"}`}>
                <aside className="sidebar left-sidebar">
                    <Button
                        icon={leftOpen ? "chevron-left" : "chevron-right"}
                        minimal
                        className="toggle-btn"
                        onClick={this.toggleLeft}
                    />
                    {leftOpen && LeftSidebar}
                </aside>

                <main className="main-content">
                    {children}
                </main>

                <aside className="sidebar right-sidebar">
                    <Button
                        icon={rightOpen ? "chevron-right" : "chevron-left"}
                        minimal
                        className="toggle-btn"
                        onClick={this.toggleRight}
                    />
                    {rightOpen && RightSidebar}
                </aside>
            </div>
        );
    }
}
